<template>
    <div class="findPwd">
       <forget-pwdTitle :active="1"></forget-pwdTitle>
        <div class="findPwd-page_main">
            <el-form class="findPwd-page_form"  label-width="80px" :model="ruleForm" ref="ruleForm">
                <send-code ref="getPhoneInfo" @submitRegForm="submitForm('userInfo')" :code-info="codeInfo" :contact-list="companyUserPhoneList" :student-no="studentNo" :user-email-level="userEmailLevel"></send-code>
                <div class="findPwd-page_submit">
                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                </div>
            </el-form>

        </div>

    </div>
</template>

<script>
import ForgetPwdTitle from "../../public/forgetPwdTitle";
import SendCode from "../../public/sendCode";
export default {
  name: "findPwdStep2",
  components: {
    forgetPwdTitle: ForgetPwdTitle,
    sendCode: SendCode
  },
  data() {
    return {
      ruleForm: {
        email: ""
      },
      //用户邮箱等级
      userEmailLevel: "",
      //学工号
      studentNo: "",
      //企业用户手机号列表
      companyUserPhoneList: [],
      codeInfo: {
        errorMsg: "",
        errorPhone: "",
        codeName: "forgetPwd"
      }
    };
  },
  methods: {
    submitForm() {
      const self = this;
      self.codeInfo.errorPhone = "";
      self.codeInfo.errorMsg = "";
      const phoneInfo = self.$refs.getPhoneInfo.phoneInfo;
      const phoneNo = phoneInfo.originalPhone;
      const msgCode = phoneInfo.code;
      const xgh =localStorage.getItem("findPwdXGH");
      //const token = localStorage.getItem("emailToken");
      if (!xgh) {
        self.$alert("会话失效，请重新找回密码", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: self.$router.push({ name: 'Step1'})
        });
      } else {
        self.$refs["getPhoneInfo"].validatePhone(valid => {
          if (valid) {
            let url=''
            if(self.userEmailLevel==='5'){
              url="/email/checkUserForDw?xgh=" +
                xgh +
                "&phone=" +
                phoneNo +
                "&code=" +
                msgCode;
            }else {
              url =
                "/email/checkUser?xgh=" +
                xgh +
                "&phone=" +
                phoneNo +
                "&code=" +
                msgCode;
            }
            self.postRequest(url, {}).then(result => {
              console.log("验证手机", result.data);
              if (result.data && result.data.msgStatus == 1) {
                localStorage.setItem("emailToken", "");
                localStorage.setItem("findPwdToken", result.data.msgCode);
                localStorage.removeItem("phone");
                localStorage.setItem("phone", phoneNo);
                localStorage.removeItem("code");
                localStorage.setItem("code", msgCode);
                self.$router.push({ name: 'Step3'})
              } else if (result.data.msgStatus == 2) {
                self.codeInfo.errorPhone = "手机号码错误";
              } else if (result.data.msgStatus == 3) {
                self.codeInfo.errorMsg = "验证码错误";
              } else {
                self.$alert("会话失效，请重新找回密码", "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                  customClass: "errMessage",
                  callback: self.$router.push({ name: 'Step1'})
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    }
  },
  mounted() {
    const self = this;
    const findPwdXGH = localStorage.getItem("findPwdXGH");
   // const emailToken = localStorage.getItem("emailToken");
    if (!findPwdXGH ) {
      self.$router.push({ name: 'Step1'})
      self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Step1'})
        }
      });
    }
    //验证邮箱等级
    const url =`/email/getAttrs?userName=${findPwdXGH}`;
    self.postRequest(url, {}).then(result => {
      if (result.data && result.data.retCode === 0) {
        const attrs = JSON.parse(result.data.result);
        const cos_id = attrs.cos_id;
        self.userEmailLevel = cos_id;
        self.studentNo = attrs.xgh;
        //if(cos_id==='5'||cos_id===5){
          //查询开放平台手机号及coremail邮箱手机号
        let xgh=findPwdXGH
        if(cos_id==='5'||cos_id===5){
          xgh=attrs.xgh
        }
        const apiUrl =`/email/getContractInfoByUserId?userId=${xgh}&type=${cos_id.toString()}`;
        self.postRequest(apiUrl, {}).then(res => {
          if(res.data.data&&res.data.data.length>0){
            res.data.data.forEach(item=>{
              item.originalPhone=atob(item.originalPhone)
            })
            self.companyUserPhoneList=res.data.data
          }else {
            self.$router.push({ name: 'Step1'})
            self.$alert("该邮箱工号未绑定手机号码,请联系邮箱管理员或者65989006", "错误提示", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
              customClass: "errMessage",
              callback: action => {
                self.$router.push({ name: 'Step1'})
              }
            });
          }
        })
        //}
      }
    });
  }
};
</script>

<style scoped>
.forgetPwd {
  width: 100%;
}
.emailAddr {
  width: 195px;
}
.emailName {
  display: inline-block;
  border: 1px solid #dcdfe6;
  width: 170px;
  text-align: center;
  margin-left: -12px;
  line-height: 38px;
}
.findPwd-page_main {
  width: 782px;
  margin: 0 auto;
  background: #fbfbfd;
  margin-top: 50px;
  padding: 50px 0;
}
.findPwd-page_form {
  width: 440px;
  margin: 0 auto;
}
.findPwd-page_submit {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.findPwd-page_submit button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
  font-size: 16px;
}
@media (max-width: 767px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
  .findPwd-page_main{
    width: 96%;
    margin-top: 20px;
    padding:20px 0 !important;
  }
  /deep/ .el-form-item__label{
    font-size: 0.8rem;
  }
  .emailAddr{
    width: 55%;
    font-size: 0.8rem;
  }
  .emailName{
    font-size: 0.8rem;
    width: 45%;
  }
  .findPwd-page_form{
    width: 96%;
  }
  .findPwd-page_submit{
    margin-top: 20px;
  }
  .findPwd-page_submit button{
    font-size: 0.8rem;
    display:flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 30px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/step2.vue